'use strict';

const formatAmount = function (forceChange = false) {
    var oldText = $('span[slot="spDisplayAmount"]').first().text();

    // Keep checking until it's updated by the widget's script
    var updatePrice = setInterval(function () {
        var text = $('span[slot="spDisplayAmount"]').first().text();

        if (oldText !== text || forceChange) {
            clearInterval(updatePrice);
            // € must be first character
            if (text.indexOf('€') !== 0) {
                return;
            }

            var updatedText = '€ ' + text.substring(1);
            $('span[slot="spDisplayAmount"]').text(updatedText);
        }
    }, 500);
}

class ScalaPay {
    run () {
        this.currentPage = $('.page').data('action') === 'Product-Show' ? 'product_page' : 'shopping_bag';
        this.availableAPI = $('.scalapay-apis') && $('.scalapay-apis').length > 0;
        this.scalaPayWidget = false;
        this.loadWidget();
    }

    // Save ScalaPay widget element, waits for script to be loaded
    loadWidget () {
        if (!this.availableAPI) {
            return;
        }

        var _self = this;
        var checkWidget = setInterval(function () {
            let scalaPayWidget = document.querySelector('scalapay-widget');

            // Save widget element and launch event observers
            if (!!scalaPayWidget) {
                clearInterval(checkWidget);
                _self.scalaPayWidget = scalaPayWidget;
                _self.prepareObservers();
                formatAmount(true);
            }
        }, 500);
    }

    // Observe analytics event
    prepareObservers () {
        var _self = this;

        for (let i = 0; i < $('scalapay-widget').length; i++) {
            $($('scalapay-widget')[i].shadowRoot).find('.sp-link, .sp-icon').on('click', function () {
                $('body').trigger('scalaPay:openModal', _self.currentPage);
            });
        }

        // When widget changes value, format amount
        $('body').on('product:afterAttributeSelect', formatAmount);
    }

    // Run at checkout
    checkout () {
        $('body').on('scalaPay:updateScalaPayPaymentMethod', function (e, order) {
            if (!$('.drawer[data-method-id="ScalaPay"]').length || !order) {
                return;
            }

            let scalaPayLabel = false;
            let showPaymentMethod = false;
            if ('scalaPaySettings' in order && order.scalaPaySettings) {
                // For multipayment
                scalaPayLabel = order.scalaPaySettings.widgetText.payment;
                showPaymentMethod = order.scalaPaySettings.isEligible;
            } else if ('scalapayTotals' in order.totals && order.totals.scalapayTotals) {
                scalaPayLabel = order.totals.scalapayTotals.payment.paymentPageWidgetText;
                showPaymentMethod = true;
            }

            if (scalaPayLabel) {
                $('.js-billing-scalapay-price').html(scalaPayLabel);
            }
            let isApplicablePaymentMethod = false;
            if (order.billing && order.billing.payment && order.billing.payment.applicablePaymentMethods) {
                for (let i = 0; i < order.billing.payment.applicablePaymentMethods.length; i++) {
                    let methodID = order.billing.payment.applicablePaymentMethods[i].ID;
                    if (methodID === 'ScalaPay') {
                        isApplicablePaymentMethod = true;
                    }
                }
            }
            if (!isApplicablePaymentMethod) {
                showPaymentMethod = false;
            }
            $('.drawer[data-method-id="ScalaPay"]').toggle(showPaymentMethod);
        });
    }
}

const scalaPay = new ScalaPay();
export default scalaPay;